__turbopack_context__.v({
  "aircraft": "hero-promotion-block-module-scss-module__WwpSXq__aircraft",
  "arrow": "hero-promotion-block-module-scss-module__WwpSXq__arrow",
  "content": "hero-promotion-block-module-scss-module__WwpSXq__content",
  "cta": "hero-promotion-block-module-scss-module__WwpSXq__cta",
  "description": "hero-promotion-block-module-scss-module__WwpSXq__description",
  "eyebrow": "hero-promotion-block-module-scss-module__WwpSXq__eyebrow",
  "inner": "hero-promotion-block-module-scss-module__WwpSXq__inner",
  "promotion": "hero-promotion-block-module-scss-module__WwpSXq__promotion",
  "title": "hero-promotion-block-module-scss-module__WwpSXq__title",
});
